import { create } from 'zustand'
import { api, setCSRFToken } from '../api/client'
import type { AuthPayload } from '../types'

interface AuthState {
  user: { username: string } | null
  ready: boolean
  checking: boolean
  check: () => Promise<void>
  login: (username: string, password: string) => Promise<void>
  logout: () => Promise<void>
  expire: () => void
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  ready: false,
  checking: false,
  check: async () => {
    set({ checking: true })
    try {
      const payload = await api<AuthPayload>('/auth/me')
      setCSRFToken(payload.csrfToken)
      set({ user: payload.user, ready: true, checking: false })
    } catch {
      setCSRFToken('')
      set({ user: null, ready: true, checking: false })
    }
  },
  login: async (username, password) => {
    const payload = await api<AuthPayload>('/auth/login', {
      method: 'POST',
      body: JSON.stringify({ username, password }),
      headers: { 'Content-Type': 'application/json' },
    })
    setCSRFToken(payload.csrfToken)
    set({ user: payload.user, ready: true })
  },
  logout: async () => {
    try {
      await api<void>('/auth/logout', { method: 'POST' })
    } finally {
      setCSRFToken('')
      set({ user: null, ready: true })
    }
  },
  expire: () => {
    setCSRFToken('')
    set({ user: null, ready: true })
  },
}))

